import tw from '../../../helpers/tailwind';

const TwoLayeredWaves = ({ className, isDark = false }) => {
  return (
    <svg
      id="visual"
      viewBox="0 0 1000 100"
      width="1000"
      height="100"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      preserveAspectRatio="none"
      className={tw('w-full h-full', className)}
    >
      <rect
        x="0"
        y="0"
        width="1000"
        height="100"
        className={isDark ? 'fill-themeDarkGrey' : 'fill-themeLightGrey'}
      ></rect>
      <path
        d="M0 67L55.5 60.2C111 53.3 222 39.7 333.2 39.7C444.3 39.7 555.7 53.3 666.8 58.7C778 64 889 61 944.5 59.5L1000 58L1000 0L944.5 0C889 0 778 0 666.8 0C555.7 0 444.3 0 333.2 0C222 0 111 0 55.5 0L0 0Z"
        className="fill-mint"
      ></path>
    </svg>
  );
};

export default TwoLayeredWaves;
